import { camelizeKeys } from "humps";
import { isEngagement, isRole } from "PFApp/activities/helpers";
import { useTemplate } from "PFApp/hooks";
import { activityCustomTypesAccessLevels } from "PFCore/helpers/custom_types";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { AccessLevel, Profile } from "PFCore/types";

export const ACTIVITY_TAG_ID = "activity_tag";
export const ACTIVITY_TAG_NOTE_ID = "activity_tag_note";

type UseManageTagsPermissions = {
  templateId: number | undefined;
  isCoowned: boolean;
  profile: Profile;
};

export const useManageTagsPermissions = ({ isCoowned, profile, templateId }: UseManageTagsPermissions) => {
  const { data: currentProfile } = useCurrentProfile();
  const { getCustomTypeByName } = useCustomTypes();

  const template = useTemplate({ id: templateId });

  const activityTagCustomType = getCustomTypeByName(ACTIVITY_TAG_ID);

  if (!activityTagCustomType) {
    return {
      canReadWriteTags: false,
      canReadTags: false
    };
  }

  const accessLevel = activityCustomTypesAccessLevels(currentProfile, camelizeKeys(profile) as Profile)[
    activityTagCustomType.id as number
  ];
  const isRoleOrEngagementActivity = isRole(template) || isEngagement(template);
  const isActivityTagAvailableInTemplate = !!template?.schema.properties[ACTIVITY_TAG_ID];

  const canReadWriteTags =
    accessLevel === AccessLevel.ReadWrite &&
    isCoowned &&
    isRoleOrEngagementActivity &&
    isActivityTagAvailableInTemplate;
  const canReadTags =
    [AccessLevel.ReadOnly, AccessLevel.ReadWrite].includes(accessLevel) &&
    isRoleOrEngagementActivity &&
    isActivityTagAvailableInTemplate;

  return {
    canReadWriteTags,
    canReadTags
  };
};
